const cart_reducer = (state, action) => {
  switch (action.type) {
    case "add_to_cart": {
      
      const { productId, SKU, price, Item, main, quantity } = action.payload;

      const existingProduct = state.cart.find((item) => item.productId === productId);

      if (existingProduct) {
        const updatedCart = state.cart.map((item) => {
          if (item.productId === productId) {
            const newQuantity = item.quantity + quantity;
            return { ...item, quantity: newQuantity };
          }
          return item;
        });

        return { ...state, cart: updatedCart };
      } else {
        const newCartItem = { productId, SKU, price, Item, main, quantity };
        return { ...state, cart: [...state.cart, newCartItem] };
      }
 
  }

    case "set_decrement": {
  const updatedCart = state.cart.map((item) => {
    if (item.SKU === action.payload) {
      const newQuantity = item.quantity > 1 ? item.quantity - 1 : 1; // ✅ Prevents quantity < 1
      return { ...item, quantity: newQuantity };
    }
    return item;
  });

  return { ...state, cart: updatedCart };
}

    case "set_increment": {
  const updatedCart = state.cart.map((item) => {
    if (item.SKU === action.payload) {
      return { ...item, quantity: item.quantity + 1 };
    }
    return item;
  });

  return { ...state, cart: updatedCart };
}

    case "remove_item": {
  const updatedCart = state.cart.filter(
    (item) => item.SKU !== action.payload
  );
  return { ...state, cart: updatedCart };
}

    case "clear_cart":
return { ...state, cart: [] };

    case "cart_item_price_total": {
  // ✅ Calculates total item count and total price
  const { total_item, total_price } = state.cart.reduce(
    (acc, item) => {
      acc.total_item += item.quantity;
      acc.total_price += item.price * item.quantity;
      return acc;
    },
    {
      total_item: 0,
      total_price: 0,
    },
  );

  return {
    ...state,
    total_item,
    total_price,
  };
}

    //adding this for functionality of loading cart only if user is logged in
    case "load_cart": {
  return {
    ...state,
    cart: action.payload,
  };
}

// update cart
case "update_quantity": {
      const { SKU, newQty } = action.payload;
      const updatedCart = state.cart.map((item) =>
        item.SKU === SKU ? { ...item, quantity: newQty } : item
      );
      return { ...state, cart: updatedCart };
    }

    default:
return state;
  }
};

export default cart_reducer;
